"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Status = void 0;
var Status;
(function (Status) {
  Status["Sent"] = "Sent";
  Status["Delivered"] = "Delivered";
  Status["Read"] = "Read";
})(Status = exports.Status || (exports.Status = {}));